import React, { useEffect, useState } from 'react';
import { HeartIcon } from 'lucide-react';
import { CallButton, WhatsAppButton } from './ui/Buttons';
export function Header() {
  const [compact, setCompact] = useState(false);
  useEffect(() => {
    const onScroll = () => setCompact(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/60 backdrop-blur-xl transition-[padding,background-color] duration-200 ease-smooth ${compact ? 'py-1.5 bg-black/80' : 'py-3'}`} data-id="element-17" data-mp="2rlvsu7tk4x9u">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-3 px-4 sm:px-6 md:flex-row md:justify-between md:gap-6" data-id="element-18" data-mp="36bl6v3mr0vrj">
        <a href="#hero" className="flex items-center gap-2.5 text-center md:text-left" data-id="element-19" data-mp="3bbfxr76ixlcl">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-red shadow-redGlow" data-id="element-20" data-mp="3fc9oe8bcpe96">
            <HeartIcon className="h-4 w-4 text-white" aria-hidden="true" data-id="element-21" data-mp="2wihx1vqug6j7" />
          </span>
          <span className={`font-display leading-none tracking-[0.12em] text-white transition-[font-size] duration-200 ease-smooth ${compact ? 'text-sm sm:text-lg' : 'text-base sm:text-2xl'}`} data-id="element-22" data-mp="2rnuhimdtimgr">
            AMARRES Y ENCANTAMIENTOS
          </span>
        </a>

        <nav aria-label="Contacto directo" className="grid w-full grid-cols-2 gap-3 md:flex md:w-auto md:gap-3" data-id="element-23" data-mp="3fd6n7c9xsceb">
          <CallButton className={`w-full md:w-auto ${compact ? 'py-2' : 'py-3'}`} data-id="element-24" data-mp="35kr9ws9l4bzr" />
          <WhatsAppButton className={`w-full md:w-auto ${compact ? 'py-2' : 'py-3'}`} data-id="element-25" data-mp="30len27ipr4x6" />
        </nav>
      </div>
    </header>;
}